import { createApp } from 'vue'
import App from './App.vue'
import { loadRuntimeConfig } from './api/client'
import './style.css'

// 先读运行时配置（决定 API 地址），再挂载应用。
// 这样后端换域名只需改 public/config.json，无需重新构建前端。
// loadRuntimeConfig 内部已吞掉所有异常，因此这里不需要 catch。
loadRuntimeConfig().then(() => {
  createApp(App).mount('#app')
})
